import FloatingLabel from './FloatingLabel';

export default FloatingLabel;
